import { createApp } from 'vue'
import App from './App.vue';
import router from './router';
import { NewToast } from "./utils";

const app = createApp(App);
app.use(router);
app.use(NewToast);
app.mount('#app');

